import { FEATURE_KEYS } from '../utils/featureConstants';

export type AccessLevel = 'full' | 'view' | 'write' | 'hidden';

export interface NavPermissionConfig {
  featureKey: number;
}

// Map the nav item 'key' (from menuConfig.tsx) to a backend feature key.
// This replaces the old role-based mapping with a granular, backend-driven system.
export const NavPermissions: Record<string, NavPermissionConfig> = {
  // Common
  'dashboard': { featureKey: FEATURE_KEYS.DASHBOARD },
  'Owner Dashboard': { featureKey: FEATURE_KEYS.OWNER_DASHBOARD },

  // Sales
  'sales': { featureKey: FEATURE_KEYS.SALES },
  'sales_history': { featureKey: FEATURE_KEYS.SALES_HISTORY },
  'pos': { featureKey: FEATURE_KEYS.POS_V2 },
  'wholesale': { featureKey: FEATURE_KEYS.WHOLESALE },

  // Pharmacy
  'pharmacy': { featureKey: FEATURE_KEYS.PHARMACY_DASHBOARD }, // Parent key or specific dashboard
  'pharmacy_dashboard': { featureKey: FEATURE_KEYS.PHARMACY_DASHBOARD },
  'pharmacy_pos': { featureKey: FEATURE_KEYS.PHARMACY_POS },
  'pharmacy_dispensing': { featureKey: FEATURE_KEYS.DISPENSING },
  'prescriptions': { featureKey: FEATURE_KEYS.PRESCRIPTIONS },
  'medications': { featureKey: FEATURE_KEYS.MEDICATIONS },
  'pharmacy_batches': { featureKey: FEATURE_KEYS.PHARMACY_BATCHES },
  'patients': { featureKey: FEATURE_KEYS.PATIENTS },
  'pharmacists': { featureKey: FEATURE_KEYS.PHARMACISTS },
  'pharmacy_branches': { featureKey: FEATURE_KEYS.PHARMACY_BRANCHES },
  'pharmacy_procurement': { featureKey: FEATURE_KEYS.PHARMACY_PROCUREMENT },
  'pharmacy_purchase_orders': { featureKey: FEATURE_KEYS.PURCHASE_ORDERS },
  'pharmacy_purchase_orders_nested': { featureKey: FEATURE_KEYS.PURCHASE_ORDERS },
  'pharmacy_goods_receiving': { featureKey: FEATURE_KEYS.DELIVERY_NOTES },
  'pharmacy_stock_transfers': { featureKey: FEATURE_KEYS.STOCK_MOVEMENTS },
  'pharmacy_reports': { featureKey: FEATURE_KEYS.PHARMACY_REPORTS },

  // Hospitality (Bar & Restaurant)
  'hospitality': { featureKey: FEATURE_KEYS.BAR_POS }, // Generic hospitality parent
  'res_dashboard': { featureKey: FEATURE_KEYS.RESTAURANT_DASHBOARD },
  'bar_dashboard_item': { featureKey: FEATURE_KEYS.BAR_DASHBOARD },
  'restaurant_tables': { featureKey: FEATURE_KEYS.RESTAURANT_TABLES },
  'restaurant_reservations': { featureKey: FEATURE_KEYS.RESTAURANT_RESERVATIONS },
  'restaurant_kitchen': { featureKey: FEATURE_KEYS.RESTAURANT_KITCHEN },
  'bar_pos': { featureKey: FEATURE_KEYS.BAR_POS },
  'bar_tabs': { featureKey: FEATURE_KEYS.BAR_TABS },
  'bar_menus': { featureKey: FEATURE_KEYS.BAR_MENUS },
  'bar_recipes': { featureKey: FEATURE_KEYS.BAR_RECIPES },
  'bar_comptoirs': { featureKey: FEATURE_KEYS.COMPTOIRS },
  'bar_shifts': { featureKey: FEATURE_KEYS.BAR_SHIFTS },
  'bar_stock': { featureKey: FEATURE_KEYS.BAR_STOCK },
  'bar_movements': { featureKey: FEATURE_KEYS.BAR_MOVEMENTS },
  'bar_analytics': { featureKey: FEATURE_KEYS.BAR_ANALYTICS },
  'restaurant_reports': { featureKey: FEATURE_KEYS.RESTAURANT_REPORTS },

  // Inventory
  'inventory': { featureKey: FEATURE_KEYS.INVENTORY },
  'store_fulfillment': { featureKey: FEATURE_KEYS.STORE_FULFILLMENT },
  'products': { featureKey: FEATURE_KEYS.PRODUCTS },
  'categories': { featureKey: FEATURE_KEYS.CATEGORIES },
  'stock_movements': { featureKey: FEATURE_KEYS.STOCK_MOVEMENTS },

  // Procurement
  'procurement': { featureKey: FEATURE_KEYS.PROCUREMENT },
  'purchase_orders': { featureKey: FEATURE_KEYS.PURCHASE_ORDERS },
  'delivery_notes': { featureKey: FEATURE_KEYS.DELIVERY_NOTES },
  'suppliers': { featureKey: FEATURE_KEYS.SUPPLIERS },

  // Finance & HRM
  'debts': { featureKey: FEATURE_KEYS.DEBTS },
  'finance': { featureKey: FEATURE_KEYS.FUNDS },
  'funds': { featureKey: FEATURE_KEYS.FUNDS },
  'expenses': { featureKey: FEATURE_KEYS.EXPENSES },
  'hrm': { featureKey: FEATURE_KEYS.HRM },
  'employees': { featureKey: FEATURE_KEYS.HRM },
  'payroll': { featureKey: FEATURE_KEYS.PAYROLL },

  // Settings
  'settings': { featureKey: FEATURE_KEYS.SETTINGS },
  'general_settings': { featureKey: FEATURE_KEYS.SETTINGS },
  'branches': { featureKey: FEATURE_KEYS.BRANCHS },
  'Audit Logs': { featureKey: FEATURE_KEYS.AUDIT_LOGS },
  'hospital_settings': { featureKey: FEATURE_KEYS.SETTINGS },

  // Hospital
  'hospital': { featureKey: FEATURE_KEYS.HOSPITAL_DASHBOARD },
  'hospital_reports': { featureKey: FEATURE_KEYS.HOSPITAL_DASHBOARD },
  'hospital_appointments': { featureKey: FEATURE_KEYS.CLINICAL_QUEUE },
  'patient_queue': { featureKey: FEATURE_KEYS.CLINICAL_QUEUE },
  'hospital_triage': { featureKey: FEATURE_KEYS.TRIAGE },
  'hospital_consultation': { featureKey: FEATURE_KEYS.CONSULTATION },
  'hospital_patients': { featureKey: FEATURE_KEYS.PATIENTS },
  'hospital_labs': { featureKey: FEATURE_KEYS.HOSPITAL_LABS },
  'hospital_wards': { featureKey: FEATURE_KEYS.HOSPITAL_WARDS },
  'hospital_finance': { featureKey: FEATURE_KEYS.HOSPITAL_MANAGEMENT },
  'hospital_pacs': { featureKey: FEATURE_KEYS.HOSPITAL_DASHBOARD },

  // Hotel & Hospitality PMS
  'hotel': { featureKey: FEATURE_KEYS.HOTEL_DASHBOARD },
  'hotel_dashboard': { featureKey: FEATURE_KEYS.HOTEL_DASHBOARD },
  'hotel_rooms': { featureKey: FEATURE_KEYS.HOTEL_ROOMS },
  'hotel_reservations': { featureKey: FEATURE_KEYS.HOTEL_RESERVATIONS },
  'hotel_housekeeping': { featureKey: FEATURE_KEYS.HOTEL_HOUSEKEEPING },
  'hotel_folios': { featureKey: FEATURE_KEYS.HOTEL_FOLIOS },
  'hotel_reports': { featureKey: FEATURE_KEYS.HOTEL_REPORTS },
  'hotel_sales_reports': { featureKey: FEATURE_KEYS.REPORTS },
  'hotel_guests': { featureKey: FEATURE_KEYS.HOTEL_GUESTS },
};
